document.addEventListener('DOMContentLoaded', function () {
  initScrollCraft();
  initFaq();
  initInfoAccordion();
  initGallery();
  initVariantPicker();
  initBundlePicker();
  initCompareSlider();
  initStickyBar();
  initBeneficiosCarousel();
  initReviews();
  initVideoCarousel();
});

/* Shopify theme editor re-renders a section's markup over AJAX when a
   merchant edits settings; re-run the init on that event so the page still
   works while customizing. Flow reveals (data-sc-in) and acts (data-sc-act)
   are handled natively by mt-engine.js, so only our own widgets need this. */
document.addEventListener('shopify:section:load', function () {
  initScrollCraft();
  initFaq();
  initInfoAccordion();
  initGallery();
  initVariantPicker();
  initBundlePicker();
  initCompareSlider();
  initStickyBar();
  initBeneficiosCarousel();
  initReviews();
  initVideoCarousel();
});

function initScrollCraft() {
  if (!window.ScrollCraft) return;
  /* mount() rebuilds its whole internal act/listener list every call, so it
     is safe to call once per real page load but not once per editor
     section:load (that would stack duplicate scroll listeners). Editing a
     cinematic section's settings in the customizer may need a manual
     preview refresh to re-run the layout pass; the published storefront is
     unaffected since it never fires shopify:section:load. */
  if (document.body.dataset.scMounted === '1') return;
  document.body.dataset.scMounted = '1';
  window.ScrollCraft.mount(document.body);
}

/* On phones, mt-engine.js opts the .mt-section[data-sc-mobile-flow] act out
   of its pinned scroll-scrub (that's a comfortable ~3 viewport-height swipe
   on desktop, but a disorienting multi-screen hold on a phone) and marks the
   section .sc-mobile-flow. Give that section its own auto-advancing
   crossfade here instead, so the 01/02/03 benefits still play out without
   asking for a long scroll. Runs once per section per page load; mount()
   already guards against double-binding on repeated shopify:section:load. */
function initBeneficiosCarousel() {
  document.querySelectorAll('.sc-mobile-flow:not([data-mt-carousel-bound])').forEach(function (section) {
    var images = section.querySelectorAll('.mt-beneficios-img');
    var items = section.querySelectorAll('.mt-beneficio-item');
    var count = Math.min(images.length, items.length);
    if (count < 2) return;
    section.setAttribute('data-mt-carousel-bound', '1');

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'mt-beneficios-dots';
    dotsWrap.setAttribute('role', 'tablist');
    var dots = [];
    for (var d = 0; d < count; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mt-beneficios-dot';
      dot.setAttribute('aria-label', 'Show benefit ' + (d + 1));
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    var list = section.querySelector('.mt-beneficios-list');
    (list || section).appendChild(dotsWrap);

    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + count) % count;
      for (var n = 0; n < count; n++) {
        images[n].classList.toggle('is-active', n === index);
        items[n].classList.toggle('is-active', n === index);
        dots[n].classList.toggle('is-active', n === index);
      }
    }

    // After the visitor takes over, wait longer before auto-advancing again.
    function restart(delay) {
      if (timer) { clearInterval(timer); clearTimeout(timer); }
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      function loop() { timer = setInterval(function () { show(index + 1); }, 3000); }
      if (delay) { timer = setTimeout(loop, delay); } else { loop(); }
    }
    function go(i) { show(i); restart(6000); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    var visual = section.querySelector('.mt-beneficios-visual');
    if (visual) {
      [['prev', -1, 'Previous benefit', '&#8249;'], ['next', 1, 'Next benefit', '&#8250;']].forEach(function (cfg) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mt-beneficios-arrow mt-beneficios-arrow--' + cfg[0];
        btn.setAttribute('aria-label', cfg[2]);
        btn.innerHTML = cfg[3];
        btn.addEventListener('click', function () { go(index + cfg[1]); });
        visual.appendChild(btn);
      });
    }

    // Swipe left/right on the photo or the text to move between benefits.
    var swipeEls = [visual, section.querySelector('.mt-beneficio-items')].filter(Boolean);
    swipeEls.forEach(function (el) {
      var x0 = null, y0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });

    show(0);
    restart();
  });
}

function initFaq() {
  document.querySelectorAll('.mt-faq-item:not([data-mt-bound])').forEach(function (item) {
    item.setAttribute('data-mt-bound', '1');
    var summary = item.querySelector('.mt-faq-q');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = item.hasAttribute('open');
      item.closest('.mt-faq-list').querySelectorAll('.mt-faq-item[open]').forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
      if (isOpen) { item.removeAttribute('open'); } else { item.setAttribute('open', ''); }
    });
  });
}

function initInfoAccordion() {
  document.querySelectorAll('.mt-info-item:not([data-mt-bound])').forEach(function (item) {
    item.setAttribute('data-mt-bound', '1');
    var summary = item.querySelector('.mt-info-q');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = item.hasAttribute('open');
      item.closest('.mt-info-list').querySelectorAll('.mt-info-item[open]').forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
      if (isOpen) { item.removeAttribute('open'); } else { item.setAttribute('open', ''); }
    });
  });
}

function initStickyBar() {
  document.querySelectorAll('.mt-producto:not([data-mt-sticky-bound])').forEach(function (root) {
    root.setAttribute('data-mt-sticky-bound', '1');
    var bar = root.querySelector('[data-mt-sticky-bar]');
    var realBtn = root.querySelector('[data-mt-add-btn]');
    var realPrice = root.querySelector('[data-mt-price]');
    if (!bar || !realBtn) return;

    var stickyBtn = bar.querySelector('[data-mt-sticky-add]');
    var stickyPrice = bar.querySelector('[data-mt-sticky-price]');
    var stickyLabel = stickyBtn ? stickyBtn.querySelector('[data-mt-sticky-label]') : null;
    var realLabel = realBtn.querySelector('[data-mt-add-label]');

    function syncPrice() {
      if (stickyPrice && realPrice) stickyPrice.textContent = realPrice.textContent;
    }
    function syncButton() {
      if (!stickyBtn) return;
      stickyBtn.disabled = realBtn.disabled;
      if (stickyLabel && realLabel) stickyLabel.textContent = realLabel.textContent;
    }
    syncPrice();
    syncButton();

    if (realPrice) new MutationObserver(syncPrice).observe(realPrice, { childList: true, characterData: true, subtree: true });
    new MutationObserver(syncButton).observe(realBtn, { attributes: true, childList: true, subtree: true });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { realBtn.click(); });
    }

    var ticking = false;
    function updateVisibility() {
      ticking = false;
      var pastIt = realBtn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', pastIt);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateVisibility);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();
  });
}

function initGallery() {
  document.querySelectorAll('.mt-producto[data-mt-gallery]:not([data-mt-bound])').forEach(function (root) {
    root.setAttribute('data-mt-bound', '1');
    var mainImg = root.querySelector('.mt-gallery-main img');
    var thumbs = root.querySelectorAll('.mt-gallery-thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (mainImg && full) { mainImg.src = full; mainImg.alt = alt; }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('.mt-producto[data-mt-variants]:not([data-mt-variants-bound])').forEach(function (root) {
    root.setAttribute('data-mt-variants-bound', '1');
    var dataEl = root.querySelector('[data-mt-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-price-was]');
    var offEl = root.querySelector('[data-mt-off]');
    function setOff(full, total) {
      if (!offEl) return;
      if (full > total) {
        offEl.textContent = Math.floor((full - total) * 100 / full) + '% off';
        offEl.style.display = '';
      } else {
        offEl.style.display = 'none';
      }
    }
    var addBtn = root.querySelector('[data-mt-add-btn]');
    var addBtnLabel = addBtn ? addBtn.querySelector('span') : null;
    var stockBadge = root.querySelector('[data-mt-stock-badge]');

    function selectedOptions() {
      var groups = root.querySelectorAll('.mt-option-group');
      var opts = [];
      groups.forEach(function (group) {
        var active = group.querySelector('.mt-swatch-btn.is-selected');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }

    function findVariant() {
      var opts = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      setOff(variant.compare_at_price || 0, variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addBtnLabel) addBtnLabel.textContent = variant.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      }
      if (stockBadge) {
        var always = stockBadge.getAttribute('data-always') === 'true';
        var threshold = parseInt(stockBadge.getAttribute('data-threshold'), 10) || 0;
        var qty = variant.inventory_quantity;
        var tracked = variant.inventory_management === 'shopify';
        if (always || (tracked && qty > 0 && qty <= threshold)) {
          stockBadge.textContent = stockBadge.getAttribute('data-label-template').replace('[qty]', qty);
          stockBadge.style.display = '';
        } else {
          stockBadge.style.display = 'none';
        }
      }
      /* Re-apply the selected tier (the 1-pack carries its own discount too) on
         top of the price/compare this just set, so switching color doesn't
         silently drop back to the undiscounted unit price. */
      var selectedTier = root.querySelector('.mt-bundle-tier.is-selected[data-qty]');
      if (selectedTier) selectedTier.dispatchEvent(new Event('click'));
    }

    root.querySelectorAll('.mt-swatch-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var group = btn.closest('.mt-option-group');
        group.querySelectorAll('.mt-swatch-btn').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateUI();
      });
    });

    updateUI();
  });
}

/* Quantity bundle (1/2/3-pack): clicking a tier sets a hidden `quantity`
   field that Shopify's own product-form.js already reads (falls back to 1
   when absent), so the real AJAX add-to-cart adds that many real units of
   whichever color is selected — inventory and fulfillment stay correct, no
   separate "bundle" variant/SKU needed. The discounted total shown here is
   purely display: the matching charge at checkout comes from the automatic
   discounts configured in Shopify admin (Discounts), not from this script.
   Assumes every variant shares one price, true for this product today; if
   colors ever price differently, tier 1's total (read at page load) is the
   one used for the "full price" comparison math below. */
function initBundlePicker() {
  document.querySelectorAll('.mt-producto:not([data-mt-bundle-bound])').forEach(function (root) {
    var bundle = root.querySelector('[data-mt-bundle]');
    if (!bundle) return;
    root.setAttribute('data-mt-bundle-bound', '1');

    var qtyInput = root.querySelector('[data-mt-bundle-qty]');
    var priceEl = root.querySelector('[data-mt-price]');
    var compareEl = root.querySelector('[data-mt-price-was]');
    var offEl = root.querySelector('[data-mt-off]');
    function setOff(full, total) {
      if (!offEl) return;
      if (full > total) {
        offEl.textContent = Math.floor((full - total) * 100 / full) + '% off';
        offEl.style.display = '';
      } else {
        offEl.style.display = 'none';
      }
    }
    var addLabelEl = root.querySelector('[data-mt-add-label]');
    var addBtn = root.querySelector('[data-mt-add-btn]');
    var tiers = bundle.querySelectorAll('.mt-bundle-tier');
    var colorsWrap = root.querySelector('[data-mt-bundle-colors]');
    var unitsHost = root.querySelector('[data-mt-bundle-units]');
    var variantDataEl = root.querySelector('[data-mt-variant-json]');
    var variants = [];
    if (variantDataEl) {
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }
    }

    var lastQty = 1;
    var unitColors = [];

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentColor() {
      var selectedSwatch = root.querySelector('.mt-swatch-btn.is-selected');
      return selectedSwatch ? selectedSwatch.getAttribute('data-value') : null;
    }

    function availableColors() {
      return Array.prototype.map.call(
        root.querySelectorAll('.mt-option-group .mt-swatch-btn:not([disabled])'),
        function (b) { return b.getAttribute('data-value'); }
      );
    }

    function variantForColor(color) {
      return variants.find(function (v) { return v.options && v.options[0] === color; });
    }

    /* The per-bottle pickers replace the single Color selector once a bundle
       is chosen, so hide the single one then (it stays in the DOM: it still
       seeds the default color and drives variant/price state). */
    function setSingleColorHidden(hidden) {
      root.querySelectorAll('.mt-option-group').forEach(function (g) { g.hidden = hidden; });
    }

    /* Circle swatches: map the variant's color word to a real color. Unknown
       colors fall back to neutral grey (the button still carries its name in
       aria-label/title, so it stays usable). */
    function swatchColor(name) {
      var n = String(name).toLowerCase();
      if (/white|cream|ivory/.test(n)) return '#FFFFFF';
      if (/green|sage|mint/.test(n)) return '#A9C094';
      if (/black/.test(n)) return '#2B2A25';
      if (/pink|rose/.test(n)) return '#E8B7C0';
      if (/blue/.test(n)) return '#8DA9C4';
      return '#C9C4B8';
    }
    function colorName(name) {
      return String(name).replace(/^(bloom|mova)s+/i, '');
    }

    function renderUnitColors(qty) {
      if (!colorsWrap || !unitsHost) return;

      var colors = availableColors();
      if (!colors.length) { colorsWrap.hidden = true; setSingleColorHidden(false); return; }

      var single = qty <= 1;
      var optionName = 'Color';
      var topLabel = root.querySelector('.mt-option-group .mt-option-label');
      if (topLabel && topLabel.textContent.trim()) optionName = topLabel.textContent.trim();
      var heading = colorsWrap.querySelector('.mt-option-label');
      if (heading) heading.hidden = single;

      if (single) {
        /* The 1-pack uses the same picker as the bundles. The hidden top
           selector still owns variant/price/stock state, so mirror any pick
           onto it instead of duplicating that logic. */
        var keep = unitColors[0] && colors.indexOf(unitColors[0]) > -1 ? unitColors[0] : (currentColor() || colors[0]);
        unitColors = [keep];
        if (keep !== currentColor()) selectTopSwatch(keep);
      } else if (qty !== lastQty || unitColors.length !== qty) {
        var fallback = unitColors[0] || currentColor() || colors[0];
        unitColors = [];
        for (var i = 0; i < qty; i++) unitColors.push(fallback);
      }
      lastQty = qty;

      unitsHost.innerHTML = '';
      unitColors.forEach(function (selected, i) {
        var row = document.createElement('div');
        row.className = 'mt-bundle-unit-row';
        var label = document.createElement('span');
        label.className = 'mt-bundle-unit-label';
        label.textContent = single ? optionName : 'Set ' + (i + 1);
        var swatches = document.createElement('div');
        swatches.className = 'mt-bundle-unit-swatches';
        var nameEl = document.createElement('span');
        nameEl.className = 'mt-bundle-unit-name';
        nameEl.textContent = colorName(selected);
        colors.forEach(function (color) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mt-bundle-unit-swatch' + (color === selected ? ' is-selected' : '');
          btn.style.setProperty('--swatch', swatchColor(color));
          btn.setAttribute('aria-label', color);
          btn.setAttribute('title', color);
          btn.addEventListener('click', function () {
            unitColors[i] = color;
            swatches.querySelectorAll('.mt-bundle-unit-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            nameEl.textContent = colorName(color);
            if (single) selectTopSwatch(color);
          });
          swatches.appendChild(btn);
        });
        row.appendChild(label);
        row.appendChild(swatches);
        row.appendChild(nameEl);
        unitsHost.appendChild(row);
      });
      colorsWrap.hidden = false;
      setSingleColorHidden(true);
    }

    function selectTopSwatch(color) {
      var swatches = root.querySelectorAll('.mt-option-group .mt-swatch-btn');
      for (var k = 0; k < swatches.length; k++) {
        if (swatches[k].getAttribute('data-value') === color) { swatches[k].click(); return; }
      }
    }

    function applyTier(tier) {
      tiers.forEach(function (t) { t.classList.remove('is-selected'); });
      tier.classList.add('is-selected');

      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var total = parseInt(tier.getAttribute('data-total'), 10) || 0;
      var full = parseInt(tier.getAttribute('data-full'), 10) || total;

      var noteEl = bundle.querySelector('[data-mt-bundle-note]');
      if (noteEl) {
        var noteText = tier.getAttribute('data-note') || '';
        noteEl.textContent = noteText;
        noteEl.hidden = !noteText;
      }
      var perksEl = bundle.querySelector('[data-mt-bundle-perks]');
      if (perksEl) {
        perksEl.hidden = qty === 1 && perksEl.getAttribute('data-tier1') !== 'true';
        /* Restart the pop-in so the perks visibly react to every tier change. */
        perksEl.classList.remove('is-pop');
        void perksEl.offsetWidth;
        perksEl.classList.add('is-pop');
      }
      if (qtyInput) qtyInput.value = qty;
      if (priceEl) priceEl.textContent = money(total);
      if (compareEl) {
        if (full > total) {
          compareEl.textContent = money(full);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      setOff(full, total);
      if (addLabelEl && addBtn) {
        var base = addBtn.getAttribute('data-label-add');
        addLabelEl.textContent = qty > 1 ? base + ' · ' + qty + 'x' : base;
      }
      renderUnitColors(qty);
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { applyTier(tier); });
    });

    applyTier(bundle.querySelector('.mt-bundle-tier.is-selected') || tiers[0]);

    /* Multi-color bundle add: when qty > 1 and the shopper picked different
       colors per unit, a single id+quantity form post can't express that —
       intercept the submit (capture phase, before Dawn's own product-form
       listener) and add each unit as its own cart line via /cart/add.js's
       `items` array instead. Re-render the same cart-drawer/notification
       sections product-form.js would, so the rest of the theme stays in
       sync. Single-color bundles and the 1-pack fall through untouched. */
    var form = root.querySelector('product-form form');
    if (form) {
      form.addEventListener('submit', function (evt) {
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        if (qty <= 1 || !unitColors.length) return;

        var items = unitColors.map(function (color) {
          var v = variantForColor(color);
          return v ? { id: v.id, quantity: 1 } : null;
        }).filter(Boolean);
        if (items.length !== qty) return; // fall back to default single-line submit if lookup failed

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('loading');
        var spinner = form.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var payload = { items: items };
        if (cart && cart.getSectionsToRender) {
          payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
        }

        fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) throw new Error(response.description || response.message || 'Cart error');
            if (cart && cart.renderContents) {
              cart.renderContents(response);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (e) {
            console.error(e);
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          })
          .finally(function () {
            addBtn.classList.remove('loading');
            addBtn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }, true);
    }
  });
}

function initCompareSlider() {
  document.querySelectorAll('[data-mt-compare]:not([data-mt-bound])').forEach(function (el) {
    el.setAttribute('data-mt-bound', '1');
    var handle = el.querySelector('.mt-compare-handle');
    var dragging = false;
    var wrap = el.closest('.mt-compare-wrap');
    function syncWrap(pct) { if (wrap) wrap.style.setProperty('--cmp', String(Math.round(pct * 10) / 10)); }
    syncWrap(parseFloat(getComputedStyle(el).getPropertyValue('--pos')) || 50);

    function setPos(clientX) {
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      el.style.setProperty('--pos', pct + '%');
      syncWrap(pct);
    }

    function start(e) {
      dragging = true;
      el.setPointerCapture && e.pointerId != null && el.setPointerCapture(e.pointerId);
      setPos(e.clientX);
    }
    function move(e) {
      if (!dragging) return;
      setPos(e.clientX);
    }
    function end() { dragging = false; }

    el.addEventListener('pointerdown', start);
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', end);
    el.addEventListener('pointerleave', end);
    el.addEventListener('pointercancel', end);

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(getComputedStyle(el).getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') { current = Math.max(0, current - 5); }
        else if (e.key === 'ArrowRight') { current = Math.min(100, current + 5); }
        else { return; }
        e.preventDefault();
        el.style.setProperty('--pos', current + '%');
        syncWrap(current);
      });
    }
  });
}

function initReviews() {
  document.querySelectorAll(".mt-resenas-wrap:not([data-mt-bound])").forEach(function (wrap) {
    wrap.setAttribute("data-mt-bound", "1");
    var track = wrap.querySelector("[data-mt-reviews-track]");
    function step(dir) {
      var card = track.querySelector(".mt-resena");
      track.scrollBy({ left: dir * (card ? card.offsetWidth + 18 : 300), behavior: "smooth" });
    }
    var prev = wrap.querySelector("[data-mt-reviews-prev]");
    var next = wrap.querySelector("[data-mt-reviews-next]");
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
  });
}

/* Video carousel: cards autoplay muted while at least 60% visible and pause
   otherwise (saves data/battery). Tapping a card toggles its sound; turning
   one on mutes the rest. Reduced-motion users get the poster until they tap. */
function initVideoCarousel() {
  document.querySelectorAll(".mt-vids-wrap:not([data-mt-bound])").forEach(function (wrap) {
    wrap.setAttribute("data-mt-bound", "1");
    var track = wrap.querySelector("[data-mt-vids-track]");
    var cards = Array.prototype.slice.call(wrap.querySelectorAll("[data-mt-vid]"));
    var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

    function setSound(card, on) {
      var v = card.querySelector("video"), b = card.querySelector("[data-mt-vid-sound]");
      v.muted = !on;
      card.classList.toggle("is-sound", on);
      if (b) { b.setAttribute("aria-pressed", on ? "true" : "false"); b.setAttribute("aria-label", on ? "Turn sound off" : "Turn sound on"); }
    }

    cards.forEach(function (card) {
      var v = card.querySelector("video");
      if (!card.querySelector("[data-mt-vid-sound]")) { v.muted = true; return; }
      card.addEventListener("click", function () {
        var turnOn = v.muted;
        cards.forEach(function (c) { setSound(c, false); });
        if (turnOn) { setSound(card, true); if (v.paused) v.play().catch(function () {}); }
      });
    });

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.querySelector("video");
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            if (!reduce) v.play().catch(function () {});
          } else {
            v.pause();
            if (!v.muted) setSound(e.target, false);
          }
        });
      }, { root: null, threshold: [0, 0.6, 1] });
      cards.forEach(function (c) { io.observe(c); });
    }

    function step(dir) {
      var card = track.querySelector(".mt-vid");
      track.scrollBy({ left: dir * (card ? card.offsetWidth + 18 : 260), behavior: "smooth" });
    }
    function checkStatic() { wrap.classList.toggle("is-static", track.scrollWidth <= track.clientWidth + 2); }
    checkStatic(); addEventListener("resize", checkStatic);
    var prev = wrap.querySelector("[data-mt-vids-prev]"), next = wrap.querySelector("[data-mt-vids-next]");
    if (prev) prev.addEventListener("click", function () { step(-1); });
    if (next) next.addEventListener("click", function () { step(1); });
  });
}
